<template>
   <!-- header start -->
   <header id="masthead" class="header prt-header-style-01">
      <!-- topbar -->
      <div class="top_bar prt-topbar-wrapper clearfix">
         <div class="container-fluid">
            <div class="row">
               <div class="col-lg-12">
                  <div class="row">
                     <div class="col-lg-6">
                        <div class="top_bar_contact_item">
                           <span>Welcome to nutricare a nutrition and diet</span>
                        </div>
                     </div>
                     <div class="col-lg-6">
                        <ul class="social-icons">
                           <li class="prt-social-facebook">
                              <a target="_blank" href="#">Facebook</a>
                           </li>
                           <li class="prt-social-instagram">
                              <a target="_blank" href="#">Instagram</a>
                           </li>
                           <li class="prt-social-twitter">
                              <a target="_blank" href="#">Twitter</a>
                           </li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- topbar-end -->
      <!-- site-header-menu -->
      <div id="site-header-menu" class="site-header-menu bg-base-white">
         <div class="site-header-menu-inner prt-stickable-header">
            <div class="container-fluid">
               <div class="row">
                  <div class="col-lg-12">
                     <div class="d-xl-flex align-items-center justify-content-between">
                        <div class="">
                           <!-- site-branding -->
                           <div class="site-branding">
                              <h1><router-link to="/" class="home-link" rel="home">
                                    <img id="logo-img" width="190" height="45" class="img-fluid" src="images/logo.png"
                                       alt="logo-img">
                                 </router-link>
                              </h1>
                              <div class="d-flex flex-row m-auto align-items-center">
                                 <div class="menu-link">
                                    <div class="btn-show-menu-mobile menubar menubar--squeeze"
                                       :class="{ 'is-active': isMobileMenuOpen }" @click="toggleMobileMenu">
                                       <span class="menubar-box">
                                          <span class="menubar-inner"></span>
                                       </span>
                                    </div>
                                    <nav class="main-menu menu-mobile" :class="{ 'active': isMobileMenuOpen }">
                                       <ul class="menu">
                                          <li v-for="(item, index) in menuItems" :key="index" class="mega-menu-item">
                                             <router-link :to="item.path" @click="closeMobileMenu">
                                                {{ item.name }}
                                             </router-link>
                                          </li>
                                       </ul>
                                    </nav>
                                 </div>
                              </div>
                           </div>
                           <!-- site-branding end -->
                        </div>
                        <div class="side-menu-container">
                           <div class="side-menu">
                              <a href="#">
                                 <i class="ti-menu"></i>
                              </a>
                           </div>
                           <div class="side-overlay">
                              <div class="side bg-base-white">
                                 <a href="#" class="close-side">
                                    <i class="icon-close"></i>
                                 </a>
                                 <div class="prt-fbar">
                                    <div class="prt-fbar-inner">
                                       <div
                                          class="prt-fbar-box-w prt-bg prt-bgimage-yes prt-bgcolor-skincolor prt-textcolor-white">
                                          <div class="prt-row-wrapper-bg-layer prt-bg-layer"></div>
                                          <div class="prt-fbar-content-wrapper">
                                             <div class="prt-fbar-content">
                                                <div class="prt-fbar-box">
                                                   <div class="floatingbar-widget-top">
                                                      <div class="prt-fbar-widget prt-fbar-widget-even">
                                                         <div class="textwidget widget-text">
                                                            <div class="prt-author-widget text-center text-base-white">
                                                               <div class="author-widget_img">
                                                                  <img src="images/author-img.jpg" class="author-img"
                                                                     alt="author-img">
                                                               </div>
                                                               <h4 class="author-name">Anjali Singh</h4>
                                                               <p class="author-widget_text">Let food be thy medicine,
                                                                  and medicine be thy food. Good nutrition is the
                                                                  foundation of good health.</p>

                                                            </div>
                                                         </div>
                                                      </div>
                                                      <div class="prt-fbar-widget prt-fbar-widget-odd">
                                                         <h3 class="widget-title">Opening Hours:</h3>
                                                         <div class="textwidget widget-text">
                                                            These are our normal opening hours. When we are closed can
                                                            be found here.<br>
                                                            <div class="prt-pricelistbox-wrapper ">
                                                               <div class="prt-pricelist-block-wrapper">
                                                                  <ul class="prt-pricelist-block mt-10">
                                                                     <li>
                                                                        <span>Monday - Friday</span>
                                                                        <p class="service-price">8.00 – 17.00</p>
                                                                     </li>
                                                                     <li>
                                                                        <span>Saturday</span>
                                                                        <p class="service-price">8.00 – 15.00</p>
                                                                     </li>
                                                                     <li>
                                                                        <span>Sunday</span>
                                                                        <p class="service-price">Closed</p>
                                                                     </li>
                                                                  </ul>
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </div>
                                                      <div class="prt-fbar-widget prt-fbar-widget-even">
                                                         <div class="featured-icon-box left-icon icon-align-top">
                                                            <div class="featured-icon">
                                                               <div
                                                                  class="prt-icon prt-icon_element-border prt-icon_element-color-white prt-icon_element-size-md prt-icon_element-style-square">
                                                                  <i class="fa fa-phone"></i>
                                                               </div>
                                                            </div>
                                                            <div class="featured-content">
                                                               <div class="featured-title">
                                                                  <h5><a href="tel:+91 896 048 6620">+91 896 048
                                                                        6620</a></h5>
                                                               </div>
                                                               <div class="featured-desc">
                                                                  <p>Have a question? call us now</p>
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                       <span class="prt-fbar-close">
                                          <span class="prt-fbar-close-icon">
                                             <i class="ti ti-close"></i>
                                          </span>
                                       </span>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- site-header-menu-end -->
   </header>
   <!-- header end -->
</template>
<script>
export default {
   name: 'AppHeader',
   data() {
      return {
         isMobileMenuOpen: false,
         menuItems: [
            { path: '/', name: 'Home' },
            { path: '/about', name: 'About' },
            { path: '/services', name: 'Service' },
            { path: '/faq', name: 'Faq' },
            { path: '/contact', name: 'Contact' }
         ]
      }
   },
   methods: {
      toggleMobileMenu() {
         this.isMobileMenuOpen = !this.isMobileMenuOpen;
      },
      closeMobileMenu() {
         this.isMobileMenuOpen = false;
      }
   },
   watch: {
      '$route'() {
         this.closeMobileMenu();
      }
   }
};
</script>

<style scoped>
.router-link-active {
   color: #9fdd0b;
   text-shadow: none;
}

.menu-mobile {
   display: none;
}

.menu-mobile.active {
   display: block;
}

@media (max-width: 991px) {
   .menu-mobile {
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      background: white;
      z-index: 999;
   }
}
</style>